import { ReactNode, useEffect } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

interface GSAPLoaderProps {
  jsContent?: string;
  title: string;
  children: ReactNode;
}

const GSAPLoader = ({ children, jsContent, title, ...props }: GSAPLoaderProps) => {
  useEffect(() => {
    ScrollTrigger.config({ limitCallbacks: true });
    gsap.registerPlugin(useGSAP, ScrollTrigger);

    window.gsap = gsap;
    window.ScrollTrigger = ScrollTrigger;

    if (jsContent) {
      try {
        const script = document.createElement('script');
        script.id = `snowflake-markup-editor-js-${title}`;
        script.textContent = jsContent;
        document.head.appendChild(script);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[GSAPLoader] Error executing jsContent:', e);
      }
    }

    return () => {
      window.gsap = undefined;
      window.ScrollTrigger = undefined;
      const script = document.getElementById(`snowflake-markup-editor-js-${title}`);
      if (script) script.remove();
    };
  }, [jsContent, title]);

  return <div {...props}>{children}</div>;
};

export default GSAPLoader;
